import {
  TwoUpProps,
  TwoUpComponentType,
} from "@bluebottlecoffee/design-system/components";
import { ElementOf } from "../utils";
import { Carousel, TwoUp as TwoUpSchema } from "../sanity-schema";
import { toImageResponsiveProps } from "./image";
import { toCopyColumnProps } from "./copy-column";
import { toCopyWithList } from "./copy-with-list";
import { toQuoteProps } from "./quote";
import { toVimeoPlayerProps } from "./vimeo-player";
import { toBulletedKeyValueListProps } from "./bulleted-key-value-list";
import { toValueProps } from "./value-props";
import { toTockProps } from "./tock";

function transform(
  module: ElementOf<TwoUpSchema["components"]>,
  bgColor: TwoUpSchema["bgColor"],
  region: string,
  lang: string,
  onClick?: () => void,
): TwoUpComponentType {
  switch (module._type) {
    case "imageResponsive":
      return {
        _type: "imageResponsive",
        ...toImageResponsiveProps(module, lang),
      };
    case "bulletedKeyValueList":
      return {
        _type: "bulletedKeyValueList",
        ...toBulletedKeyValueListProps(module, bgColor, region, lang),
      };
    case "carousel": {
      const m: Carousel = module;
      return {
        _type: "carousel",
        ...{ images: m.images.map((i) => toImageResponsiveProps(i, lang)) },
      };
    }
    case "copyColumn":
      return {
        _type: "copyColumn",
        ...toCopyColumnProps(module, region, lang),
      };
    case "tock":
      return {
        _type: "tock",
        ...toTockProps(module, region, lang),
      };
    case "copyWithList":
      return {
        _type: "copyWithList",
        ...toCopyWithList(module, lang, onClick),
      };
    case "quote":
      return {
        _type: "quote",
        ...toQuoteProps(module, lang),
      };
    case "vimeoPlayer":
      return {
        _type: "vimeoPlayer",
        ...toVimeoPlayerProps(module),
      };
    case "valueProps":
      return {
        _type: "valueProps",
        ...toValueProps(module, lang, region),
      };
    default: {
      throw Error(`Two up transform failed`);
    }
  }
}

export function toTwoUpProps(
  data: TwoUpSchema,
  region: string,
  lang: string,
  onClick?: () => void,
): TwoUpProps {
  return {
    bgColor: data.bgColor,
    layout: data.layout,
    components: [
      transform(data.components[0], data.bgColor, region, lang, onClick),
      transform(data.components[1], data.bgColor, region, lang, onClick),
    ],
    mobileRenderingOrder:
      data.mobileRenderingOrder === "reverse" ? "reverseColumn" : "column",
  };
}
